
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const TemplatesService = {

    getTemplates: (account: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-templates/${account}`);
    },

    toggleStatus: (data: {templete_id: number, status: 1 | 2 | 3}) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/chage-status-template-text`, data);
    },
    
    toggleFileStatus: (data: {templete_id: number, status: 1 | 2 | 3}) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/chage-status-template-file`, data);
    },

    saveTextTemplate: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addTemplates`, data );
    },

    saveImageTemplate: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/saveImage`, data);
    },

    saveFileTemplate: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/saveFile`, data);
    },
  
    updateTextTemplate: (data) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/edit-template-text`, data);
    },

    updateFileTemplate: (data) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/edit-template-file`, data);
    },

}